<template>
  <toast v-model="showToast" v-if="showToast" :msg="msg"></toast>
</template>
<script>
import { mapState } from 'vuex'
import Toast from '@/components/Toast'
import { getarticles } from '@/services/article.js'
import { errorReport } from '@/utils/index.js'
import tujialogin from '@/utils/tujialogin.js'
import { mpUtils } from '@tujia/fe-lib-bridge'
import { wrapAuthorizeUrl } from '@common-libs/tj-channel/elong'
import { channelTypes } from '@common-libs/tj-channel'

export default {
  mixins: [tujialogin],

  components: {
    Toast
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      showToast: false,
      msg: 'hello world'
    }
  },
  computed: {
    ...mapState(['houseFilter'])
  },
  watch: {
    payLoad(newVal) {
      // eslint-disable-next-line
      if (newVal && newVal.type === 'jumpArticleDetail') {
        this.jumpArticleDetail(newVal.articleId)
      }
    }
  },
  mounted() {
    this.initArticle()
  },
  methods: {
    /**
     * 初始化文章信息
     */
    async initArticle() {
      const { articleInfoList } = this.compProps?.mate?.privateProps
      const list = []
      articleInfoList && articleInfoList.forEach((item) => {
        item.id && list.push(item.id)
      })
      try {
        const ret = await getarticles({ articleIds: list })
        const data = {
          items: [],
          totalCount: 0
        }
        if (ret.errcode === 0 && ret.data) {
          data.items = ret.data || []
          data.totalCount = ret.data.length
        }
        data.items = data.items && data.items.map((item) => {
          // 头图
          let headImage = item.headImage && item.headImage.url ? item.headImage.url : (item.articleImage ? item.articleImage.url : '')
          const isReg = /^(http|https)/
          if (headImage && !isReg.test(headImage)) {
            headImage = this.picHost + headImage
          }
          const content = item.content ? JSON.parse(item.content) : []
          // 标题
          const title = item.title || content[0]?.textVo?.text
          // 亮点
          const article = articleInfoList.find((one) => {
            return Number(one.id) === Number(item.articleId)
          })
          return {
            ...item,
            headImage,
            title,
            highlightsText: article?.highlightsText || ''
          }
        })
        this.$emit('init', data)
      } catch (e) {
        errorReport(e)
      }
    },
    /**
     * 跳转文章详情
     * @param {Number} articleId 文章id
     */
    async jumpArticleDetail(articleId) {
      const { code = `cms_${this.$root.promotionId}` } = this.$route.query
      const { isTujiaAppEnv, isCtripAppEnv, isQunarAppEnv, isWxMpEnv } = this.platformEnv
      const pwaTHost = window.location.host.indexOf('fvt') > -1 || window.location.host.indexOf('beta') > -1 ? 'https://pwa.fvt.tujia.com' : 'https://pwa.tujia.com'
      const h5Url = `${pwaTHost}/h5/appw/discoverychannel/articledetails?articleid=${articleId}&navbar=0&code=${code}&isFeed=1`
      try {
        if (isTujiaAppEnv) {
          // T
          const url = `tujia://tujia.com/web?url=${encodeURIComponent(h5Url)}`
          window.location.href = url
        } else if (isWxMpEnv) {
          // 小程序
          const wxUrl = this.tjChannelId === channelTypes.ELONG ? `/page/home/webview/webview?src=${encodeURIComponent(wrapAuthorizeUrl(h5Url))}` : `/pages/tbnb/pages/common/webview/index?optionsData={"h5url":"${encodeURIComponent(h5Url)}","needLogin":false}`
          mpUtils.navigateTo({
            url: wxUrl
          })
        } else if (isCtripAppEnv) {
          // 携程
          const url = `https://m.ctrip.com/webapp/newbnb/transform.html?islogin=1&targeturl=${encodeURIComponent(h5Url)}`
          if (window.CtripUtil && window.CtripUtil.app_open_url) {
            window.CtripUtil.app_open_url(url, 2, '', '', true)
            return
          }
          window.location.href = url
        } else if (isQunarAppEnv) {
          // 去哪儿
          const url = `https://bnb.qunar.com/tjbnb/app/index.jsp?#/passport?targetType=tujiapwa&forceLogin=1&redirect=${encodeURIComponent(h5Url)}`
          if (window.hysdk && window.hysdk.openWebView) {
            window.hysdk && window.hysdk.openWebView({ url })
            return
          }
          window.location.href = url
        } else {
          // 移动端浏览器
          window.location.href = h5Url
        }
      } catch (e) {
        errorReport(e)
      }
    }
  }
}
</script>
